import {User} from './user';

export class Exercise {
    constructor(
        name: String,
        description: String,
        date: Date,
        rm: Number,
        medida: String,
        user:User
    ){}
}


// WEBPACK FOOTER //
// ./src/models/exercise.ts